import { useState, createContext, useContext, useCallback } from 'react';

import config from '../config/index';

const StreamlineMode = createContext();
const SetStreamlineMode = createContext();
const ToggleStreamlineMode = createContext();
const FieldsChanged = createContext();
const SetFieldsChanged = createContext();

export function useStreamlineContext() {
  return useContext(StreamlineMode);
}
export function useSetStreamlineContext() {
  return useContext(SetStreamlineMode);
}
export function useToggleStreamlineContext() {
  return useContext(ToggleStreamlineMode);
}

export function useFieldsChangedContext() {
  return useContext(FieldsChanged);
}
export function useSetFieldsChangedContext() {
  return useContext(SetFieldsChanged);
}

export function ContextProvider({ children }) {
  const [fieldsChanged, setFieldsChanged] = useState(config.fieldsChangedInit);
  const [isStreamline, setIsStreamline] = useState(false);

  const toggleStreamline = useCallback(
    () => setIsStreamline((curr) => !curr),
    [setIsStreamline]
  );

  return (
    <StreamlineMode.Provider value={isStreamline}>
      <SetStreamlineMode.Provider value={setIsStreamline}>
        <ToggleStreamlineMode.Provider value={toggleStreamline}>
          <FieldsChanged.Provider value={fieldsChanged}>
            <SetFieldsChanged.Provider value={setFieldsChanged}>
              {children}
            </SetFieldsChanged.Provider>
          </FieldsChanged.Provider>
        </ToggleStreamlineMode.Provider>
      </SetStreamlineMode.Provider>
    </StreamlineMode.Provider>
  );
}
